import ListCourseRequest from './list/ListCourseRequest'

export default function CourseRequestManagementPage() {
  return <ListCourseRequest />
}
